import {noView, inject, LogManager} from "aurelia-framework";
import {SortableFormLayout} from "./sortable-form-collection";
import {BindingSignaler} from "aurelia-templating-resources";
import {EventAggregator} from "aurelia-event-aggregator";
import {I18N} from "aurelia-i18n";
import {Client} from "../../api/client";
import {DialogService} from "aurelia-dialog";

const logger = LogManager.getLogger("SortableDaysCollection");
logger.setLevel(LogManager.logLevel.none); // Disable logging for this class by setting "LogManager.logLevel.none"

@noView
export class CancellationFormLayout {
    activate(field) {
        this.config = field;
        this.fields = field.fields;

        this.groupFieldsByColumn(this.config, this.fields);

        field.addRemoveCallback = this._update.bind(this);
    }

    _update() {
        this.groupFieldsByColumn(this.config, this.fields);
    }

    groupFieldsByColumn(config, fields) {
        let otherFields = [];
        let returnValue = {};
        let columns = {};

        for (let field of fields) {

            if (field.options?.rowId && field.options?.columnId) {

                let rowId = field.options?.rowId;
                let columnId = field.options?.columnId;

                if (!returnValue[rowId]) {
                    returnValue[rowId] = {};
                }

                if (!returnValue[rowId][columnId]) {
                    returnValue[rowId][columnId] = [];
                }

                returnValue[rowId][columnId].push(field);
                columns[columnId] = field;

            } else {
                otherFields.push(field);
            }
        }

        this.otherFields = otherFields;
        this.grouped = Object.values(returnValue);
        this.columns = columns;
    }
}
